import React from 'react';

export default function Supplier360() {
  const selectTab = (tab, event) => window.s360tab(tab, event.currentTarget);

  return (
    <div
      className="overlay"
      id="s360overlay"
      onClick={(event) => {
        if (event.target === event.currentTarget) window.closeS360();
      }}
    >
      <div className="s360">
        <div className="s360-head">
          <div>
            <div className="s360-name" id="s360name">AHB Pharma</div>
            <div className="s360-meta" id="s360meta">
              Vendor ID VMS-0142 · Medicine category · Active since 2019
            </div>
          </div>
          <button className="s360-close" type="button" onClick={() => window.closeS360()} aria-label="Close Supplier 360">
            ✕
          </button>
        </div>
        <div className="s360-tabs">
          <button className="s360-tab active" type="button" data-p="overview" onClick={(event) => selectTab('overview', event)}>Overview</button>
          <button className="s360-tab" type="button" data-p="performance" onClick={(event) => selectTab('performance', event)}>Performance</button>
          <button className="s360-tab" type="button" data-p="risk" onClick={(event) => selectTab('risk', event)}>Risk</button>
          <button className="s360-tab" type="button" data-p="documents" onClick={(event) => selectTab('documents', event)}>Documents</button>
        </div>
        <div className="s360-body">
          <div className="s360-panel active" id="p-overview">
            <div className="s360-kpis">
              <div className="s360-kpi"><div className="l">YTD spend</div><div className="v" id="s360Spend">₹18.4L</div></div>
              <div className="s360-kpi"><div className="l">Performance score</div><div className="v" id="s360Score">88 / 100</div></div>
              <div className="s360-kpi"><div className="l">Active POs</div><div className="v">7</div></div>
              <div className="s360-kpi"><div className="l">On-time delivery</div><div className="v" id="s360OTD">94%</div></div>
            </div>
            <table>
              <thead>
                <tr><th>PO number</th><th>Item</th><th>Amount</th><th>Status</th></tr>
              </thead>
              <tbody>
                <tr><td>PO1023</td><td>Carmozyme 250mg</td><td>₹45,000</td><td><span className="pill amber">Pending</span></td></tr>
                <tr><td>PO1019</td><td>Analgesic Syrup</td><td>₹22,300</td><td><span className="pill blue">In transit</span></td></tr>
                <tr><td>PO1011</td><td>Antibiotic Cap 500</td><td>₹61,800</td><td><span className="pill green">Delivered</span></td></tr>
              </tbody>
            </table>
          </div>
          <div className="s360-panel" id="p-performance">
            <div className="chart-wrap inline-style-18">
              <canvas aria-label="Line chart of vendor performance score over the last 6 months" id="chS360Perf" role="img" />
            </div>
          </div>
          <div className="s360-panel" id="p-risk">
            <div className="risk-badges">
              <div className="risk-badge inline-style-54"><b>Financial</b>Low risk</div>
              <div className="risk-badge inline-style-55"><b>Delivery</b>Medium risk</div>
              <div className="risk-badge inline-style-54"><b>Compliance</b>Low risk</div>
              <div className="risk-badge inline-style-54"><b>Quality</b>Low risk</div>
            </div>
            <p className="inline-style-56">
              Delivery risk flagged due to 2 late shipments last quarter, both linked to a raw-material shortage the vendor disclosed proactively.
            </p>
          </div>
          <div className="s360-panel" id="p-documents">
            <div className="doc-row"><span>GST registration certificate</span><span className="pill green">Valid</span></div>
            <div className="doc-row"><span>Drug manufacturing license</span><span className="pill green">Valid</span></div>
            <div className="doc-row"><span>ISO 9001 certification</span><span className="pill amber">Expires in 18 days</span></div>
            <div className="doc-row"><span>Bank verification letter</span><span className="pill green">Valid</span></div>
          </div>
        </div>
      </div>
    </div>
  );
}
